import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { EmailArray } from "../../../data/arrayData";
import ResizeListener from "../../../utility/ResizeListener";
import BodyComponent from "../../components/BodyComponent";
import SidebarLayout from "../../components/SidebarLayout";
import {
  BeneficiaryManagment,
  CustomerManagement,
} from "../../resources/assetsManager";
import {
  BENEFICIARY_TAB,
  CUSTOMERS_TAB,
  PAY_IN,
} from "../../resources/constantsManager";
import BeneficiaryIndex from "./beneficiary/BeneficiaryIndex";
import Customers from "./Customers";
import { useLocation } from "react-router";

function CustomerIndex({ profileDetails }) {
  const [currentTab, setCurrentTab] = useState(
    // EmailArray.includes(profileDetails?.emailId)
    //   ? CUSTOMERS_TAB
    //   : BENEFICIARY_TAB
    CUSTOMERS_TAB
  );
  const { height } = ResizeListener();
  const location = useLocation();

  const TransactionMenu = [
    {
      name: "Customer",
      icon: CustomerManagement,
      key: CUSTOMERS_TAB,
    },
    // {
    //   name: "Beneficiary",
    //   key: BENEFICIARY_TAB,
    //   icon: BeneficiaryManagment,
    // },
  ];

  useEffect(() => {
    if (location?.state?.isBackToBeneficiaryTab) {
      setCurrentTab(BENEFICIARY_TAB);
    }
  }, [location]);
  return (
    <>
      <SidebarLayout
        //profileDetails?.payOutStatus
        // menu={profileDetails?.payOutStatus ? TransactionMenu : TransactionMenu1}

        // menu={TransactionMenu2}
        // EmailArray.includes(profileDetails?.emailId)
        //   ? TransactionMenu
        //   : TransactionMenu2

        menu={TransactionMenu}
        passCurrentTab={(tab) => {
          setCurrentTab(tab);
        }}
        activeTab={currentTab}
      />{" "}
      <BodyComponent style={{ width: "100%", overflow: "hidden" }}>
        {currentTab === CUSTOMERS_TAB ? <Customers /> : <BeneficiaryIndex />}
      </BodyComponent>
      ;
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    profileDetails: state.profileDetailsReducer.details,
  };
};
export default connect(mapStateToProps)(CustomerIndex);
